import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {MenuItem as RmwcMenuItem} from '@rmwc/menu'
import '@rmwc/menu/styles'

export const StyledRmwcMenuItem = styled(RmwcMenuItem)``

const MenuItem = ({children, ...otherProps}) => <StyledRmwcMenuItem {...otherProps}>{children}</StyledRmwcMenuItem>

MenuItem.propTypes = {
  children: PropTypes.any
}

export {MenuItem}
